export default __webpack_public_path__ + "static/SRF 4420 - Product Specifications & Technical Data-5c627b45049817a79480819ba422dc10.pdf";